<div style="display: flex; flex-direction: column">
    <label class="header">
        {{ question.label }}
    </label>
    <small
        *ngIf="question.subLabel"
        style="color: gray; margin-left: 15px; margin-bottom: 8px"
        >{{ question.subLabel }}</small
    >
</div>

<nz-radio-group
    style="margin-left: 15px"
    *ngIf="question.type === 'polar_check'"
    [name]="question.field"
    [(ngModel)]="data.isNo"
    [ngModelOptions]="{ standalone: true }"
    [nzDisabled]="!editMode"
>
    <label nz-radio [nzValue]="false">Yes</label>
    <label nz-radio [nzValue]="true">No</label>
</nz-radio-group>

<div *ngIf="!data.isNo" class="container">
    <my-health-admin-answer
        [field]="question.field"
        [answer]="question.answer"
        [question]="question"
        [data]="data"
        [editMode]="editMode"
        [answers]="answers"
        [brand]="brand"
        [allAnswers]="allAnswers"
        [customerId]="customerId"
    ></my-health-admin-answer>

    <input
        *ngIf="question.type === 'select'"
        type="text"
        class="hidden"
        [name]="'validAnswer_' + question.field"
        [ngModel]="validateCheck"
        required
    />
</div>
